/**
 * Influencer feature access by plan — keep in sync with payments/config/influencerFeatureAccess.config.js
 */

export const INFLUENCER_FEATURES = {
  MEDIA_YOUTUBE: 'media_youtube',
  MEDIA_INSTAGRAM: 'media_instagram',
  AUTOMATION_DM: 'automation_dm',
  AFFILIATE_LINK: 'affiliate_link',
  LINK_MANAGEMENT: 'link_management',
};

export const PLAN_FEATURES = {
  free: [
    INFLUENCER_FEATURES.MEDIA_YOUTUBE,
    INFLUENCER_FEATURES.MEDIA_INSTAGRAM,
  ],
  premium: [
    INFLUENCER_FEATURES.MEDIA_YOUTUBE,
    INFLUENCER_FEATURES.MEDIA_INSTAGRAM,
    INFLUENCER_FEATURES.AUTOMATION_DM,
    INFLUENCER_FEATURES.AFFILIATE_LINK,
    INFLUENCER_FEATURES.LINK_MANAGEMENT,
  ],
};

export function hasInfluencerFeature(planType, featureKey) {
  const plan = PLAN_FEATURES[planType] ? planType : 'free';
  return (PLAN_FEATURES[plan] || PLAN_FEATURES.free).includes(featureKey);
}

export function isPaidInfluencerPlan(planType) {
  return planType === 'premium';
}
